import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 12px;
    padding: 15px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 10px;
  }
`;

export const ImgBox = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-radius: 12px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 40px;
    height: 40px;
    padding: 5px;
    border-radius: 10px;
  }
`;

export const Names = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const Name = styled(Typography.Caption).attrs({
  $variant: '2',
})``;

export const SubName = styled(Typography.Title)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const Stats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0px;
  }
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 8 1 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    height: 37px;
    min-width: 80px;

    &:first-child {
      flex: 11 1 0;
      min-width: 120px;
    }

    &:last-child {
      min-width: 0;
    }
  }
`;

export const StatLabel = styled(Typography.Body).attrs({
  $variant: '4',
})`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;

export const StatValueWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const StatValue = styled(Typography.Body)<{ $isRed?: boolean }>`
  font-size: 16px;
  font-weight: 500;

  ${({ $isRed }) =>
    $isRed &&
    css`
      color: ${({ theme }) => theme.palette.system.red};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const UntilDate = styled(Typography.Body).attrs({
  $variant: '3',
})``;
